module.exports = __webpack_public_path__ + "img/2-explorations-light.56a42115.svg";